<template>
  <v-row justify="center">
    <v-col v-for="(item, index) in dialogAccountPass" :key="index">
      <v-btn text dark @click.stop="dialog = true">
        <span class="d-flex primary--text text-capitalize text-caption">{{ item.btn }}</span>
      </v-btn>
      <v-dialog v-model="dialog" max-width="450">
        <v-card>
          <v-card-title class="text-h6 ml-n1">{{ item.title }}</v-card-title>
          <v-card-text class="mb-0 pb-2">{{ item.text }}</v-card-text>
          <v-col cols="12">
            <v-form class="mx-4" width="70%" ref="myForm">
              <v-form-base 
                id="form-base-complete" 
                :schema="schemaForm" 
                :model="modelForm" 
                @input="log" @click="log" 
              />
            </v-form>
            <v-col cols="12" class="d-flex justify-center">
              <v-btn
                class="secundary2 white--text mb-3 text-capitalize"
                @click="reSendCode"
                disabled
                v-if="timerActive === true"
              >
                Reenviar código
                <span class="text-lowercase">({{ timerCount }} seg.)</span>
              </v-btn>
              <v-btn class="secundary2 white--text mb-3 text-capitalize" @click="reSendCode" v-else>
                Enviar código
              </v-btn>
            </v-col>
            <v-divider></v-divider>
            <div class="mt-4">
              <div class="ma-auto position-relative" style="max-width: 300px">
                <span class="d-flex text-caption justify-center mb-2">{{ item.text2 }}</span>
                <v-otp-input
                  v-model="otp"
                  length="6"
                  :disabled="loading"
                  @finish="onFinish"
                ></v-otp-input>
                <v-overlay absolute :value="loading">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </v-overlay>
              </div>
              <span class="d-flex justify-center text-caption mt-1">
                {{ text }}
              </span>
            </div>
          </v-col>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false">
              {{ item.btn2 }}
            </v-btn>
            <v-btn color="primary" text @click="dialog = false"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import VFormBase from 'vuetify-form-base';

export default {
  name: 'VDialogAccountPass',
  components: {
    VFormBase,
  },
  props: ['dialogAccountPass'],
  data() {
    return {
      dialog: false,
      loading: false,
      otp: '',
      text: '',
      timerActive: false,
      timerCount: 0,
      modelForm: {},
      schemaForm: {
        passwordNew: {
          type: 'password',
          label: 'Contraseña nueva',
          appendIcon: 'mdi-eye',
          clearable: true,
          outlined: true,
          dense: true,
          hideDetails: true,
          flex: {
            xs: 12,
            sm: 8
          },
          class: 'mx-2',
        },
        pinNew: {
          type: 'text',
          label: 'PIN nuevo',
          hint: '4 dígitos',
          maxlength: '4',
          clearable: true,
          outlined: true,
          dense: true,
          flex: {
            xs: 12,
            sm: 4
          },
          class: 'mx-2',
        },
      },
    };
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters('proAccountPage', ['statusPro']),
    ...mapGetters('patAccountPage', ['statusPat']),
  },
  methods: {
    handleEvents() {},

    log(val) {
      let { on, key, obj, params } = val;
      if (
        on === 'click' &&
        key === 'subgroups.content' &&
        (params && params.tag) === 'prepend-inner'
      ) {
        window.print();
      }
      if (on === 'click' && key === 'passwordNew' && (params && params.tag) === 'append') {
        obj.schema.type === 'password'
          ? (obj.schema.appendIcon = 'mdi-eye-off')
          : (obj.schema.appendIcon = 'mdi-eye');
        obj.schema.type = obj.schema.type === 'password' ? 'text' : 'password';
      }
    },

    async onFinish() {
      this.loading = true;

      let model = {};
      model = this.modelForm;
      model.otp = this.otp;

      if (this.$route.name === 'my-account') {
        this.$store.dispatch('proAccountPage/passAccount', { model }).then(
          () => {
            if (this.statusPro === true) {
              setTimeout(() => {
                this.loading = false;
                this.text = 'La contraseña y el pin se modificaron correctamente.';
              }, 1500);
              this.otp = '';
              this.text = '';
              this.modelForm = {};
            } else if (this.statusPro === false) {
              setTimeout(() => {
                this.loading = false;
                this.text = 'Código de verificación es incorrecto';
              }, 1500);
            }
          },
          () => {
            setTimeout(() => {
              this.loading = false;
              this.text = 'Código de verificación es incorrecto';
            }, 1500);
          }
        );
      } else if (this.$route.name === 'my-account-pat') {
        this.$store.dispatch('patAccountPage/passAccount', { model }).then(
          () => {
            if (this.statusPat === true) {
              setTimeout(() => {
                this.loading = false;
                this.text = 'La contraseña y el pin se modificaron correctamente.';
              }, 1500);
              this.otp = '';
              this.text = '';
              this.modelForm = {};
            } else if (this.statusPat === false) {
              setTimeout(() => {
                this.loading = false;
                this.text = 'Código de verificación es incorrecto';
              }, 1500);
            }
          },
          () => {
            setTimeout(() => {
              this.loading = false;
              this.text = 'Código de verificación es incorrecto';
            }, 1500);
          }
        );
      }
      this.otp = '';
      this.text = ' ';
    },
    async reSendCode() {
      this.otp = '';
      this.text = ' ';
      this.timerCount = 30;
      this.timerActive = true;

      setTimeout(() => {
        this.timerActive = false;
        this.timerCount = 0;
      }, 30000);

      let model = {};
      model = this.modelForm;
      model.otp = this.otp;

      if (this.$route.name === 'my-account') {
        this.$store.dispatch('proAccountPage/reSendCode', { model }).then(
          () => {
            if (this.statusPro === true) {
              setTimeout(() => {
                this.loading = false;
                this.text = 'Se ha enviado un Código de verificación a tu email';
              }, 1500);
              this.otp = '';
              this.text = '';
            } else if (this.statusPro === false) {
              setTimeout(() => {
                this.loading = false;
                this.text = 'Hubo un error al enviar el código; inténtelo nuevamente.';
              }, 1500);
            }
          },
          () => {
            setTimeout(() => {
              this.loading = false;
              this.text = 'Hubo un error al enviar el código; inténtelo nuevamente.';
            }, 1500);
          }
        );
      } else if (this.$route.name === 'my-account-pat') {
        this.$store.dispatch('patAccountPage/reSendCode', { model }).then(
          () => {
            if (this.statusPat === true) {
              setTimeout(() => {
                this.loading = false;
                this.text = 'Se ha enviado un Código de verificación a tu correo';
              }, 1500);
              this.otp = '';
              this.text = '';
            } else if (this.statusPat === false) {
              setTimeout(() => {
                this.loading = false;
                this.text = 'Hubo un error al enviar el código; inténtelo nuevamente.';
              }, 1500);
            }
          },
          () => {
            setTimeout(() => {
              this.loading = false;
              this.text = 'Hubo un error al enviar el código; inténtelo nuevamente.';
            }, 1500);
          }
        );
      }
    },
  },
};
</script>

<style>
#form-base-complete .key-subgroups-content {
  background-color: #faf3e9;
  padding: 1rem;
}

#form-base-complete .key-subgroups-tasks {
  background-color: #e2eaf5;
  padding: 1rem;
}

@media print {
  html * {
    position: fixed;
    top: 0;
    bottom: 0;
    visibility: hidden;
  }

  .key-subgroups-content textarea {
    visibility: visible;
    left: 0;
    top: 0;
    bottom: 0;
  }

  .key-subgroups-content textarea * {
    visibility: visible;
  }
}
</style>
